// extracted by mini-css-extract-plugin
module.exports = {"container-out-of-orders":"OrderDetails_container-out-of-orders__YeqJ2","container-banner":"OrderDetails_container-banner__kPsyN"};